import React from 'react';

const NewHampshire = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        New Hampshire Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Limited disclosures required; standard form provided by the New
          Hampshire Association of Realtors.
        </li>
        <li>Water Supply and Sewage Disposal Disclosure: Required.</li>
        <li>Lead Paint Disclosure: Mandatory for homes built before 1978.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/New-Hampshire-Buyers-Notification-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Buyer's Notification Disclosure{' '}
          </span>{' '}
          – Prior to executing a purchase closure.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/New-Hampshire-Property-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – The seller is required to attach the property disclosure statement
          to the purchase agreement and inform the buyer of specific aspects of
          the property.
        </li>
      </ol>
    </div>
  );
};

export default NewHampshire;
